// import posthog from "posthog-js";

// export const initPostHog = () => {
//   if (typeof window === "undefined") {
//     return;
//   }

//   if (posthog.__loaded) {
//     return;
//   }

//   const apiKey = process.env.GATSBY_POSTHOG_KEY;
//   const apiHost =
//     process.env.GATSBY_POSTHOG_HOST;

//   if (!apiKey) {
//     console.warn("PostHog API key is missing");
//     return;
//   }

//   posthog.init(apiKey, {
//     api_host: apiHost,
//     capture_pageview: true,
//     capture_pageleave: true,
//   });
// };

// export default posthog;




import posthog from "posthog-js";

export const EVENT_PREFIX = "sg.";

export const initPostHog = () => {
  if (typeof window === "undefined" || posthog.__loaded) return;

  const posthogKey = process.env.GATSBY_POSTHOG_KEY || 'phc_syugwJ5djuy6aqp6nNGWPQ6Ku4QHGLMDWonozaNpZcsa';
  if (!posthogKey) {
    console.warn("PostHog API key is missing");
    return;
  }

  posthog.init(posthogKey, {
    api_host: process.env.GATSBY_POSTHOG_HOST || 'https://app.posthog.com',
    capture_pageview: true,
    capture_pageleave: true,
    loaded: (ph) => {
      ph.identify(ph.get_distinct_id());
    },
  });
};

export const postHogCaptureAnalytics = (key, properties = {}, options) => {
  console.log('postHogCaptureAnalytics')
  if (!posthog.__loaded) return;
  
  // console.log("capturing analytics", EVENT_PREFIX + key, properties)

  posthog.capture(EVENT_PREFIX + key, properties, options);
};

export default posthog;

